/**
 * Fix element when scroll passes a certain distance.
 * @param {string|Element} selector - The element or selector to fix.
 * @param {number} offset - Offset from top (for fixed position).
 * @param {string} fixedClass - Class to add when fixed.
 * @param {number} showAt - Scroll distance (px) to start showing/fixing the element.
 *   If not set, will use element's initial position as before.
 */
export function fixedOnScroll(
    selector,
    offset = 0,
    fixedClass = "is-fixed",
    showAt = null,
    callback = null
) {
    const el =
        typeof selector === "string"
            ? document.querySelector(selector)
            : selector;
    if (!el) return;
    const initialTop =
        el.getBoundingClientRect().top + window.pageYOffset - offset;
    const triggerAt = typeof showAt === "number" ? showAt : initialTop;

    function onScroll() {
        if (window.pageYOffset >= triggerAt) {
            el.classList.add(fixedClass);
            if (callback) callback(true);
        } else {
            el.classList.remove(fixedClass);
            if (callback) callback(false);
        }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
}
